import { Tooltip } from '@mui/material';

// The info variant used to sit on a cool #f5faff, which read blue against the
// warm palette; every variant now draws its pair from the status tokens.
const buildVariant = ({ surface, text }) => ({
  backgroundColor: surface,
  color: text,
  '& .MuiTooltip-arrow': { color: surface }
});

const TOOLTIP_VARIANTS = {
  error: buildVariant({ surface: 'var(--color-danger-surface)', text: 'var(--color-danger)' }),
  warning: buildVariant({ surface: 'var(--color-warning-surface)', text: 'var(--color-warning)' }),
  info: buildVariant({ surface: 'var(--color-surface-light)', text: 'var(--color-content)' }),
  success: buildVariant({ surface: 'var(--color-primary-surface)', text: 'var(--color-success)' })
};

const TooltipWrapper = ({ 
  children, 
  showTooltip = false, 
  title = '', 
  variant = 'info',
  placement = 'top',
  arrow = true,
  leaveDelay = 100,
  ...tooltipProps 
}) => {
  if (!showTooltip || !title) {
    return <>{children}</>;
  }

  const variantStyles = TOOLTIP_VARIANTS[variant] || TOOLTIP_VARIANTS.info;

  return (
    <Tooltip
      title={title}
      arrow={arrow}
      placement={placement}
      leaveDelay={leaveDelay}
      slotProps={{
        tooltip: {
          sx: {
            fontSize: '14px',
            padding: '10px',
            fontFamily: 'inherit',
            textAlign: 'center',
            ...variantStyles
          }
        }
      }}
      {...tooltipProps}
    >
      {children}
    </Tooltip>
  );
};

export default TooltipWrapper;